import { render, staticRenderFns } from "./BookingListItem.vue?vue&type=template&id=1310011c"
import script from "./BookingListItem.vue?vue&type=script&lang=ts"
export * from "./BookingListItem.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports